import React from 'react';
import Dialog from '@mui/material/Dialog';
import "../css/Popup.css";

export default function DialogModal(props) {

  const {open,component} = props;

  return (
    <>
      <Dialog open={open} className="CustomDialog">
        {component}
      </Dialog>
    </>
  );
}